import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=8ff45a92&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "./SideBar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SideBar.vue?vue&type=style&index=1&id=8ff45a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff45a92",
  null
  
)

export default component.exports